
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from "vue-property-decorator";
import { BgInputNumber } from "@banggood/scm-fe";
import { SupplierForm } from "@/service/supplier-meta/common/SupplierForm";
import { ElementUIFormRules } from "@/service/supplier-meta/common/supplier-field-ctrl";
import { Form } from "element-ui";
@Component({
  components: {
    BgInputNumber,
  },
})
export default class ProductionInfo extends SupplierForm {
  form = {
    factoryInfo: {
      isPartCut: false,
      factoryManufactureInfo: {
        /** 大货生产时效 */
        bulkProductionTime: null as number | null,
        /** 首单生产周期/天  */
        firstOrderProductionCycle: null as number | null,
        /** 订单交付周期/天 */
        orderProductionCycle: null as number | null,
        /** 场地规模/㎡ */
        siteScale: null as number | null,
        /** 仓储/㎡  */
        storage: null as number | null,
        /** 总产能*月/万件 */
        totalCapacity: null as number | null,
        /** 工厂产能*月万件  */
        factoryCapacity: null as number | null,
        /** 外发工厂产能*月/万件 */
        outsourceFactoryCapacity: null as number | null,
      },
    },
  };
  get rules(): ElementUIFormRules {
    return this.getFieldsRules([
      "factoryInfo.isPartCut",
      "factoryInfo.factoryManufactureInfo.bulkProductionTime",
      "factoryInfo.factoryManufactureInfo.firstOrderProductionCycle",
      "factoryInfo.factoryManufactureInfo.orderProductionCycle",
      "factoryInfo.factoryManufactureInfo.siteScale",
      "factoryInfo.factoryManufactureInfo.storage",
      "factoryInfo.factoryManufactureInfo.totalCapacity",
      "factoryInfo.factoryManufactureInfo.factoryCapacity",
      "factoryInfo.factoryManufactureInfo.outsourceFactoryCapacity",
    ]);
  }
  getFormRef() {
    return this.$refs.form as Form;
  }
  getFormData() {
    return {
      ...this.form,
    };
  }
}
